var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1399_738)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1399_738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H60V60H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1399_738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7903 30.8721C21.7903 28.0695 19.5224 25.8017 16.7199 25.8017",
    stroke: "#A3E9E6",
    strokeWidth: 1.59505,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8035 30.8721C51.8035 28.0695 54.0713 25.8017 56.8739 25.8017",
    stroke: "#A3E9E6",
    strokeWidth: 1.59505,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8035 9.45431C51.8035 12.2568 54.0713 14.5247 56.8739 14.5247",
    stroke: "#A3E9E6",
    strokeWidth: 1.59505,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7969 9.3752H55.0518C56.1019 9.3752 56.9531 10.2265 56.9531 11.2766V29.05C56.9531 30.1002 56.1019 30.9514 55.0518 30.9514H42.0703",
    stroke: "#A3E9E6",
    strokeWidth: 1.59505,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5234 30.9514H18.542C17.492 30.9514 16.6406 30.1002 16.6406 29.05V18.8742",
    stroke: "#A3E9E6",
    strokeWidth: 1.59505,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.752 17.5059C32.7088 15.6979 34.609 14.4661 36.797 14.4661C39.9472 14.4661 42.5011 17.0199 42.5011 20.1702C42.5011 23.3205 39.9472 25.8744 36.797 25.8744C34.3808 25.8744 32.3155 24.3722 31.4841 22.2507",
    stroke: "#A3E9E6",
    strokeWidth: 1.59505,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4845 3.04705H28.4774C30.1461 3.04705 31.768 3.59971 33.0895 4.61877L39.2579 9.37518H26.5148C25.1713 9.37518 24.0822 10.4643 24.0822 11.8079C24.0822 12.693 24.563 13.5083 25.3375 13.9366L31.3665 17.271C32.6166 17.9623 33.1723 19.4647 32.6731 20.8031C32.1878 22.1041 30.8445 22.8746 29.4765 22.6368L25.2434 21.9008C21.3009 21.2152 17.5613 19.6585 14.297 17.3439H11.4845",
    stroke: "#A3E9E6",
    strokeWidth: 1.59505,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4844 19.9219H1.17188V1.17188H11.4844V19.9219Z",
    stroke: "#A3E9E6",
    strokeWidth: 1.59505,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5068 57.4221H25.5486C21.4883 57.4221 17.5943 55.8092 14.7232 52.9381L8.35672 46.5716C7.21708 45.432 7.22141 43.5827 8.36645 42.4484C9.50399 41.3214 11.3386 41.3258 12.4707 42.4582L18.1674 48.1566C20.0766 50.0663 22.6663 51.1392 25.3666 51.1392H31.6972",
    stroke: "#A3E9E6",
    strokeWidth: 1.59505,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6154 51.139H25.8546C24.2525 51.139 22.9537 49.8402 22.9537 48.2381C22.9537 46.636 24.2525 45.3372 25.8546 45.3372H33.2536L34.784 43.5204C36.6885 41.2598 39.4937 39.955 42.4496 39.955C44.5643 39.955 46.6248 40.6238 48.3363 41.8659L48.5067 41.9895",
    stroke: "#A3E9E6",
    strokeWidth: 1.59505,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8281 58.8284H48.5156V40.0784H58.8281V58.8284Z",
    stroke: "#A3E9E6",
    strokeWidth: 1.59505,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1399_738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI1);
export default __webpack_public_path__ + "static/media/i1.3e4aca0e0268fc02b1e73b3815b4bf62.svg";
export { ForwardRef as ReactComponent };